import PublicPage from "./PublicPage.jsx";
import { SUPPORT_EMAIL } from "./legalInfo.js";

export default function RefundsPage({ onNavigate, onGetStarted }) {
  return (
    <PublicPage
      title="Refund & Cancellation Policy"
      lastUpdated="August 2026"
      onNavigate={onNavigate}
      onGetStarted={onGetStarted}
    >
      <section className="legal-section">
        <h2 className="landing-h2 legal-h2">Right of withdrawal</h2>
        <p className="legal-p">
          You have the right to withdraw from your purchase within fourteen
          (14) calendar days of the transaction date, without giving any
          reason, in accordance with EU Consumer Rights Directive
          2011/83/EU (Art. 9).
        </p>
        <p className="legal-p">
          To exercise this right, notify us by email at{" "}
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a> within the
          14-day window. A plain statement of your intention to withdraw is
          sufficient — no form is required.
        </p>
      </section>

      <section className="legal-section">
        <h2 className="landing-h2 legal-h2">Effect of credit consumption</h2>
        <p className="legal-p">
          Scan credits are a consumable digital good. The right of
          withdrawal expires in respect of any credits that have already
          been used to scan a receipt, in accordance with Art. 16(m) CRD.
          This means:
        </p>
        <ul className="legal-list">
          <li>
            <strong>Unused credits</strong> — if you request withdrawal
            within 14 days and credits remain in your balance, we will
            refund the value of those unused credits.
          </li>
          <li>
            <strong>Used credits</strong> — credits already spent on a scan
            cannot be refunded; the right of withdrawal has expired for
            that portion of your purchase.
          </li>
        </ul>
        <p className="legal-p">
          Refunds for unused credits are processed within 14 days of
          receiving your withdrawal notice, using the original payment
          method and at no additional cost to you.
        </p>
      </section>

      <section className="legal-section">
        <h2 className="landing-h2 legal-h2">Technical failures</h2>
        <p className="legal-p">
          If credits are deducted from your balance due to a verified
          technical error on our part — for example a scan that failed but
          was charged anyway — we will restore those credits within 5
          business days of confirming the issue. Contact{" "}
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
        </p>
      </section>

      <section className="legal-section">
        <h2 className="landing-h2 legal-h2">No subscription</h2>
        <p className="legal-p">
          Simple Expense Management does not offer subscriptions. There is
          nothing to cancel. You simply stop buying credits when you no
          longer wish to use the service. Unused purchased credits do not
          expire and remain in your account indefinitely.
        </p>
      </section>

      <section className="legal-section">
        <h2 className="landing-h2 legal-h2">Disputes</h2>
        <p className="legal-p">
          If you are unable to resolve a concern with us directly, EU
          consumers may use the European Commission's Online Dispute
          Resolution platform at{" "}
          <a
            href="https://ec.europa.eu/consumers/odr"
            target="_blank"
            rel="noopener noreferrer"
          >
            ec.europa.eu/consumers/odr
          </a>
          . Our contact email for dispute purposes is{" "}
          <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>.
        </p>
      </section>
    </PublicPage>
  );
}
